import React from "react";

function footer() {
  return (
    <footer id="footer" className="flex justify-center flex-shrink-0 bg-gray-200 p-4 mt-auto">
      <div className="w-1/3 text-center">LA_ILA2_1304</div>
      <div className="w-1/3 text-center">Dominik & Sandro</div>
      <div className="w-1/3 text-center">BBBaden 2023</div>
    </footer>
  );
}

export default footer;
